module.exports = __webpack_public_path__ + "static/media/29.aed13b2d.png";